
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppDateTimePicker, AppButton } from '@/components';
import { useTicketAdd } from '@/modules/scratch/ticket/model/add';
import { ScratchTicketType, ScratchTicketOptions } from '@/modules/scratch/ticket/model/mixins';
import { ROUTE_NAME_SCRATCH } from '@/modules/scratch/router';

export default defineComponent({
    name: ROUTE_NAME_SCRATCH.TICKET.ADD,
    components: { AppFormRow, AppInput, AppSelect, AppDateTimePicker, AppButton, AppCard },
    setup() {
        const { model, v$, fetchIapOptions, iapOptions, timeUnits, actions } = useTicketAdd();

        onMounted(() => {
            fetchIapOptions();
        });

        return { model, v$, iapOptions, ScratchTicketOptions, ScratchTicketType, timeUnits, actions };
    }
});
